import { ReactNode } from "react";
import { colors } from "theme";

import ContentContainer from "components/ContentContainer";
import Flex from "components/Flex";

type StickyButtonsBoxProps = {
  children: ReactNode;
  shadow?: boolean;
};

export const StickyButtonsBox = ({ children, shadow = false }: StickyButtonsBoxProps) => (
  <Flex
    p={24}
    gap={16}
    style={{
      ...(shadow ? { boxShadow: "0px -3px 6px rgba(0, 0, 0, 0.1)" } : {}),
      background: colors.white,
      width: "100%",
      position: "sticky",
      bottom: 0,
      zIndex: 3,
    }}
  >
    <ContentContainer>{children}</ContentContainer>
  </Flex>
);
